import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  CorporateDefaultBillableRateDto,
  CorporateFacilityDifferentialRatesDto,
  CreateCorporateDefaultBillableRateDto
} from '../../models';

@Injectable({ providedIn: 'root' })
export class CorporateBillableRatesService {
  private readonly baseUrl = '/api/corporate';
  private readonly http = inject(HttpClient);

  // ============================================
  // ENDPOINT 8: GET /api/corporates/{id}/billable-rates
  // Get corpoate billable rates
  // ============================================
  getAll(corporateId: string): Observable<CorporateDefaultBillableRateDto[]> {
    return this.http.get<CorporateDefaultBillableRateDto[]>(
      `${this.baseUrl}/${corporateId}/billable-rates`
    );
  }

  get(
    corporateId: string,
    billrateId: string
  ): Observable<CorporateDefaultBillableRateDto[]> {
    return this.http.get<CorporateDefaultBillableRateDto[]>(
      `${this.baseUrl}/${corporateId}/billable-rates/${billrateId}`
    );
  }

  // ============================================
  // ENDPOINT 9: POST /api/corporates/{id}/billable-rates
  // Set corpoate billable rate
  // ============================================
  create(
    corporateId: string,
    body: CreateCorporateDefaultBillableRateDto
  ): Observable<CorporateDefaultBillableRateDto> {
    return this.http.post<CorporateDefaultBillableRateDto>(
      `${this.baseUrl}/${corporateId}/billable-rates`,
      body
    );
  }

  update(
    corporateId: string,
    billrateId: string,
    body: Partial<CreateCorporateDefaultBillableRateDto>
  ): Observable<CorporateDefaultBillableRateDto> {
    return this.http.put<CorporateDefaultBillableRateDto>(
      `${this.baseUrl}/${corporateId}/billable-rates/${billrateId}`,
      body
    );
  }

  delete(corporateId: string, billrateId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/${corporateId}/billable-rates/${billrateId}`
    );
  }

  // ============================================
  // ENDPOINT 10: GET /api/corporates/{id}/billable-rates/{scope}
  // Get current billable rate for a scope
  // ============================================
  getCurrentRateByScope(
    corporateId: string,
    scope: ScopeOfPracticeEnum
  ): Observable<number | null> {
    return this.http.get<number | null>(
      `${this.baseUrl}/${corporateId}/billable-rates/scope/${scope}`
    );
  }

  getDifferentialRates(
    corporateId: string
  ): Observable<CorporateFacilityDifferentialRatesDto[]> {
    return this.http.get<CorporateFacilityDifferentialRatesDto[]>(
      `${this.baseUrl}/${corporateId}/billable-rates/differential-rates`
    );
  }
}
